<div class="modal-header">
    <h6 class="modal-title medium" *ngIf="!ccConversion">{{'confirmation' | translate}}</h6>
    <h6 class="modal-title medium" *ngIf="ccConversion">{{'convertToConfirmedCase' | translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body">
    <h6 class="mb-2 medium" [innerHTML]="confirmationMessage"></h6>
    <div *ngIf="ccConversion">
        <div class="w-100 float-left relative">
            <input class="form-control" [ngStyle]="{'background-color':'white'}" placeholder="YYYY-MM-DD"
                   name="ccDate" [(ngModel)]="ccDate" ngbDatepicker (ngModelChange)="onDateChange($event)"
                   #d="ngbDatepicker" readonly [maxDate]="maxDate" [minDate]="minDate" required>
            <button class="iga-right" (click)="d.toggle(); openDatePicker(d)" type="button">
                <i class="fa fa-calendar"></i>
            </button>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> {{'cancel' |
        translate}}
    </button>
    <button class="btn btn-primary float-right" *ngIf="!forceResign" (click)="confirm()"> {{'confirm' | translate}}
    </button>
    <button class="btn btn-primary float-right" *ngIf="forceResign" (click)="actionResignConfirmed()"
            [disabled]="disabledButton"> {{'resign' | translate}}
    </button>
    <button class="btn btn-primary float-right" *ngIf="bulkResign" (click)="forceResignConfirmed()"
            [disabled]="disabledButton"> {{'forceResign' | translate}}
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/confirmation/confirmation.html